import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useDropzone } from "react-dropzone";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

export default function FileInput(props) {
  const { onFileDrop, accept } = props;
  const [rejectedMsg, setRejectedMsg] = useState("");
  const { getRootProps, getInputProps } = useDropzone({
    // optional - e.g. { "application/pdf": [".pdf"] }, if not set all file types are allowed
    accept,
    onDrop: (acceptedFiles, fileRejections) => {
      setRejectedMsg(
        fileRejections.length > 0
          ? "File type not allowed: " + fileRejections.map((r) => r.file.name).join(", ")
          : ""
      );
      if (acceptedFiles.length > 0) onFileDrop(acceptedFiles);
    },
  });

  return (
    <Box
      {...getRootProps()}
      sx={{
        border: 1,
        borderRadius: 1,
        p: 2,
        textAlign: "center",
        borderStyle: "dashed",
      }}
    >
      <CloudUploadIcon fontSize="large" color="action" />
      <Typography variant="body2">
        Drag and drop files here, or click to select files (
        {props.formats || "PDF and XML files only"})
      </Typography>
      {rejectedMsg && (
        <Typography variant="body2" color="error">{rejectedMsg}</Typography>
      )}

      <Typography variant="body2">{props.description}</Typography>
      <input {...getInputProps()} />
    </Box>
  );
}
